var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotDelivered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#E20004"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2928 7.19546C12.5661 6.92215 12.5661 6.47829 12.2928 6.20498C12.0195 5.93167 11.5757 5.93167 11.3024 6.20498L9 8.50953L6.69546 6.20717C6.42215 5.93386 5.97829 5.93386 5.70498 6.20717C5.43167 6.48048 5.43167 6.92433 5.70498 7.19764L8.00953 9.5L5.70717 11.8045C5.43386 12.0779 5.43386 12.5217 5.70717 12.795C5.98048 13.0683 6.42433 13.0683 6.69764 12.795L9 10.4905L11.3045 12.7928C11.5779 13.0661 12.0217 13.0661 12.295 12.7928C12.5683 12.5195 12.5683 12.0757 12.295 11.8024L9.99047 9.5L12.2928 7.19546Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotDelivered);
export default __webpack_public_path__ + "static/media/not-delivered.955b1791a4d778cf9cedda231ea0010b.svg";
export { ForwardRef as ReactComponent };